module.exports = __webpack_public_path__ + "static/media/p2.952bf705.jpg";